import {useMemo} from 'react';

import {useMetricStatisticsQueryQuery} from '../../../../../generated/graphql';

type MetricStatisticForRun = {
  last: number;
  max: number;
  min: number;
  run_name: string;
};
export function useMetricStatisticsForRun({
  currentKey,
  entityName,
  filters,
  order,
  projectName,
  shouldSkip,
}: {
  currentKey?: string;
  entityName: string;
  filters: string;
  order: string;
  projectName: string;
  shouldSkip: boolean;
}): {
  metricStatisticsForRun: MetricStatisticForRun[];
  metricStatisticsForRunError?: Error;
  metricStatisticsForRunLoading: boolean;
} {
  // Get the metric statistics for each run
  const {
    data,
    error: metricStatisticsForRunError,
    loading: metricStatisticsForRunLoading,
  } = useMetricStatisticsQueryQuery({
    context: {
      propagateErrors: true,
    },
    variables: {
      filters: filters,
      limit: 100,
      order: order,
      metricName: currentKey ?? '', // this cannot be hit because the query will be skipped when `currentKey` doesn't exist
      entityName,
      projectName,
    },
    skip: shouldSkip,
  });

  const metricStatisticsForRun = useMemo(() => {
    try {
      return (data?.project?.runs?.metricStatistics ?? []).map(
        (ms: MetricStatisticForRun) => ({
          run_name: ms.run_name,
          min: ms.min,
          max: ms.max,
          last: ms.last,
        })
      );
    } catch (e) {
      return [];
    }
  }, [data]);

  return useMemo(
    () => ({
      metricStatisticsForRun,
      metricStatisticsForRunError,
      metricStatisticsForRunLoading,
    }),
    [
      metricStatisticsForRun,
      metricStatisticsForRunError,
      metricStatisticsForRunLoading,
    ]
  );
}
